<template>
  <div class="form-input-simple-with-suggestions">
    <el-col
      :span="6" class="el-col--min-14em">
      <el-input-number
         v-model="simple.value"
         class="w-100"
        :step="1"
        :min="validation.min"
        :max="validation.max"
        :disabled="disabled"
        @change="update">
      </el-input-number>
    </el-col>
    <el-col v-if="expressedInUnit" class="el-col--offset-1em" :span="1">
      {{ expressedInUnit }}
    </el-col>
    <el-col :span="6" class="el-col--offset-1em">
      <el-dropdown class="w-100" @command="setValue">
        <el-button class="w-100" :disabled="disabled">
          {{ $t('label.suggestions') }} <i class="el-icon-arrow-down el-icon--right"></i>
        </el-button>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item v-for="option in options" :key="option.code" :command="String(option.value)">{{ `${option.name} (${option.value}${expressedInUnit || ''})` }}</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </el-col>
  </div>
</template>

<script>
import { get, has } from 'lodash';

export default {
  name: 'evolution-settings-form-input-simple-with-suggestions',
  props: {
    id: {
      required: true,
      default: null,
    },
    code: {
      required: true,
      default: null,
    },
    options: {
      required: true,
      default: null,
    },
    description: {
      required: true,
      default: null,
    },
    input: {
      required: true,
      default: null,
    },
    value: {
      required: true,
      default: null,
    },
    placeholder: {
      type: String,
      required: false,
      default: '',
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false,
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false,
    },
    validation: {
      type: Object,
      required: false,
      default: null,
    },
    expressedInUnit: {
      type: String,
      required: false,
      default: null,
    },
    dependsOnCustom: {
      required: false,
      default: null,
    },
    calculated: {
      required: false,
      default: false,
    },
    calculatedFrom: {
      required: false,
      default: null,
    },
  },
  data() {
    return {
      isDisabled: this.disabled,
      simple: {
        id: null,
        code: null,
        value: null,
        description: null,
      },
    };
  },
  methods: {
    setValue(value) {
      this.simple.value = value;
      this.update(value);
    },
    update(value) {
      this.$emit('set:value', {
        code: this.simple.code,
        data: {
          measurement_setting_type_id: this.simple.id,
          value: Number(value),
        },
      });
    },
    setRule() {
      this.$emit('set:rule', {
        code: this.code,
        validation: this.validation,
        calculated: this.calculated,
      });
    },
  },
  created() {
    this.setRule();

    this.simple.id = this.id;
    this.simple.code = this.code;
    this.simple.description = this.description;

    const min = has(this.validation, 'min') ? this.validation.min : null;
    this.simple.value = get(this.input, 'value') || min;
    this.update(this.simple.value);
  },
};
</script>

<style lang="scss">
  .form-input-simple-with-suggestions {
    .el-button.is-disabled, .el-button.is-disabled:focus, .el-button.is-disabled:hover {
      background-color: #f7f7f7;
      border-color: #f7f7f7;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/professional/persons/participants/participant-evolution/settings/evolution-settings-form-input/cmpt-form-input-simple-with-suggestions.vue